

























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Popup from '@/components/default/Popup.vue';
import { IMeasurementDto, MeasurementStatus } from '@/data/web-api-client';
import TaskPopup from '@/modules/shared/tasks/components/TaskPopup.vue';

@Component({
  components: {
    Popup,
    TaskPopup,
  },
})
export default class MeasurementFinishedPopup extends Vue {
    @Prop({ required: true })
    private data!: IMeasurementDto;
    private show: boolean = false;

    public open() {
        this.show = true;
    }

    private createQuotaitonTask() {
        this.show = false;
        const dialog = (this.$refs.TaskPopup as TaskPopup);
        dialog.dto.title = 'Offerte maken';
        dialog.dto.type = 4;
        dialog.dto.projectId = this.data.projectId!;
        dialog.show();
    }
}
